module.exports = __webpack_public_path__ + "static/media/bnr4.ce8bc117.gif";